import { createStore } from "redux";

export const CHANGE_ACTIVITY = "CHANGE_ACTIVITY";
export const CHANGE_ACCOUNT = "CHANGE_ACCOUNT";
export const CHANGE_COURSES = "CHANGE_COURSES";
export const CHANGE_SESSIONS = "CHANGE_SESSIONS";
export const CHANGE_POLLS = "CHANGE_POLLS";
export const CHANGE_COURSE_ID = "CHANGE_COURSE_ID";
export const CHANGE_SEL_ROLE = "CHANGE_SEL_ROLE";

export const changeActivity = (data) => ({
  type: CHANGE_ACTIVITY,
  data,
});

export const changeAccount = (data) => ({
  type: CHANGE_ACCOUNT,
  data,
});

export const changeCourses = (data) => ({
  type: CHANGE_COURSES,
  data,
});

export const changeSessions = (data) => ({
  type: CHANGE_SESSIONS,
  data,
});

export const changePolls = (data) => ({
  type: CHANGE_POLLS,
  data,
});

export const changeCourseID = (data) => ({
  type: CHANGE_COURSE_ID,
  data,
});

export const changeSelRole = (data) => ({
  type: CHANGE_SEL_ROLE,
  data,
});

let initialState = {
  
    /*account:{
        //accountID: User credential if anonymous; otherwise user email,
        accountEmail: 'johnsmith@ucsd.edu',
        accountFirstName: 'John',
        accountLastName: 'Smith',
        accountIdentifier: '12345678',
        accountType: 'instructor',
        accountAdmin: 'false',
    },*/
     
  account: {},

  
     /*activity:{
         activityCourseID: 'testCourseID',
         activitySessionID: 'testSessionID',
         activityPollID: 'testPollID',
     },*/
     
  activity: {},

  /*
     courseID: {
         courseID: 'testCourseID',
         courseName: 'testCourseName',
         courseTerm: 'testCourseTerm',
         courseCategories: {
            'testCategoryName': [
                'testOptionName',
            ]
         },
         courseCode: 'testCourseCode',
         courseSessionID: 'testCourseSessionID',
         coursePollID: 'testCoursePollID',
         students: [],
         isActive: boolean,
     };
     */
  courses: {},

  /*
     sessionID: {
         sessionID: 'testSessionID' + i,
         sessionIndex: i,
         sessionStartTime: 123456789,
         sessionCourseID: 'testCourseID' + i,
     };
     */
  sessions: {},

  /*
     pollID: {
         pollID: 'testPollID' + i,
         pollIndex: i,
         pollStartTime: 123456789,
         pollSessionID: 'testSessionID' + i,
         pollVotedColor: '#123456',
     };
     */
  polls: {},
  courseID: "",
  selRole: "",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_ACTIVITY: {
      let newActivity = action.data;
      return Object.assign({}, state, {
        activity: newActivity,
      });
    }
    case CHANGE_ACCOUNT: {
      let newAccount = action.data;
      return Object.assign({}, state, {
        account: newAccount,
        selRole:  state.account.accountType === undefined ? (newAccount.accountType === "ta" ? "student" : newAccount.accountType) : ((newAccount.accountType !== state.account.accountType) ? newAccount.accountType : state.selRole), //(state.account.accountType === undefined || newAccount.accountType !== state.account.accountType) ? newAccount.accountType : state.selRole,
      });
    }
    case CHANGE_COURSES: {
      let newCourses = action.data;
      return Object.assign({}, state, {
        courses: newCourses,
      });
    }
    case CHANGE_SESSIONS: {
      let newSessions = action.data;
      return Object.assign({}, state, {
        sessions: newSessions,
      });
    }
    case CHANGE_POLLS: {
      let newPolls = action.data;
      return Object.assign({}, state, {
        polls: newPolls,
      });
    }
    case CHANGE_COURSE_ID: {
      let newCourseID = action.data;
      return Object.assign({}, state, {
        courseID: newCourseID,
      });
    }
    case CHANGE_SEL_ROLE: {
      let newRole = action.data;
      return Object.assign({}, state, {
        courses: {},
        sessions: {},
        polls: {},
        selRole: newRole,
      });
    }
    default:
      return state;
  }
};

export const store = createStore(reducer);
